import { gql } from "@apollo/client";
import { FINDING_STATES_FIELDS } from "~/operations/fragments/FindingStatesFields";

export const GET_FINDINGS = gql`
  query GetFindings(
    $scopeMrn: String!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $orderBy: FindingsOrder
    $filter: FindingsFilter
  ) {
    findings(
      scopeMrn: $scopeMrn
      first: $first
      after: $after
      last: $last
      before: $before
      orderBy: $orderBy
      filter: $filter
    ) {
      ... on FindingsConnection {
        totalCount
        filteredTotalCount
        edges {
          cursor
          node {
            ... on CveFinding {
              id
              mrn
              title
              asset {
                icon
                name
                id
                mrn
                tags {
                  key
                  value
                }
              }
              cases {
                totalCount
                edges {
                  node {
                    status
                    mrn
                    createdAt
                    ticketRefs {
                      type
                    }
                  }
                }
              }
              rating
              riskValue
              lastUpdated
              publishedAt
              state
              states {
                ...FindingStatesFields
              }
              tags {
                key
                value
              }
              spaceRiskDelta {
                delta
                effort
                manualEffort {
                  research
                  rollout
                  scripting
                  totalManualEffort
                  verification
                }
              }
              riskFactors {
                mrn
                indicator
                title
                affected
                total
                isPositive
              }
              exception {
                id
                exceptionId
                exceptionMrn
                scope
                reviewStatus
                status
                justification
                action
                author {
                  name
                  email
                  type
                }
                createdAt
              }
            }
            ... on AdvisoryFinding {
              id
              mrn
              title
              asset {
                id
                mrn
              }
              cases {
                totalCount
                edges {
                  node {
                    status
                    mrn
                    createdAt
                    ticketRefs {
                      type
                    }
                  }
                }
              }
              rating
              riskValue
              lastUpdated
              publishedAt
              firstDetectedAt
              iconId
              tags {
                key
                value
              }
              spaceRiskDelta {
                delta
                effort
                manualEffort {
                  research
                  rollout
                  scripting
                  totalManualEffort
                  verification
                }
              }
              riskFactors {
                mrn
                indicator
                title
                affected
                total
                isPositive
              }
              state
              states {
                ...FindingStatesFields
              }
              exception {
                id
                exceptionId
                exceptionMrn
                scope
                reviewStatus
                status
                justification
                action
                author {
                  name
                  mrn
                  email
                  type
                }
                createdAt
              }
            }
            ... on CheckFinding {
              id
              mrn
              title
              asset {
                id
                mrn
              }
              cases {
                totalCount
                edges {
                  node {
                    status
                    mrn
                    createdAt
                    ticketRefs {
                      type
                    }
                  }
                }
              }
              rating
              state
              states {
                ...FindingStatesFields
              }
              resultType
              riskValue
              lastUpdated
              tags {
                key
                value
              }
              spaceRiskDelta {
                delta
                effort
                manualEffort {
                  research
                  rollout
                  scripting
                  totalManualEffort
                  verification
                }
              }
              riskFactors {
                mrn
                indicator
                title
                affected
                total
                isPositive
              }
              exception {
                id
                exceptionId
                exceptionMrn
                scope
                reviewStatus
                status
                action
                justification
                author {
                  name
                  mrn
                  email
                  type
                }
                createdAt
              }
            }
            ... on GenericFinding {
              id
              mrn
              title
              asset {
                id
                mrn
              }
              rating
              riskValue
              lastUpdated
              state
              states {
                ...FindingStatesFields
              }
              tags {
                key
                value
              }
              exceptions {
                id
                exceptionId
                exceptionMrn
                scope
                reviewStatus
                status
                justification
                action
                author {
                  name
                  email
                  type
                }
                createdAt
              }
            }
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
      ... on RequestError {
        message
        code
      }
      ... on NotFoundError {
        message
        code
      }
    }
  }
  ${FINDING_STATES_FIELDS}
`;
